import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  Output
} from '@angular/core';

@Component({
  selector: 'app-deadline-picker',
  templateUrl: './deadline-picker.component.html',
  styleUrls: ['./deadline-picker.component.scss']
})
export class DeadlinePickerComponent implements AfterViewInit {
  @Input() deadline: string;
  @Input() duringSetup = false;
  @Input() isOverridden = false;
  @Output() emitSelectedTime = new EventEmitter<string>();

  selectedTime: string;
  displayTimepicker = false;
  timeSuggestions = [
    { name: '06:00', value: '06:00' },
    { name: '07:00', value: '07:00' },
    { name: '08:00', value: '08:00' },
    { name: '16:00', value: '16:00' }
  ];

  constructor() {}

  ngAfterViewInit() {
    this.selectedTime = this.deadline;
  }

  toggleTimepicker() {
    this.displayTimepicker = !this.displayTimepicker;
    this.selectedTime = this.deadline;
  }

  selectTime(event: any) {
    this.selectedTime = event.detail.value;
  }

  emitTime() {
    this.emitSelectedTime.emit(this.selectedTime);
    this.displayTimepicker = false;
  }

  useSuggestion(time: { name: string; value: string }) {
    this.selectedTime = time.value;
  }
}
